<template lang="pug">
  card-front(
    @click="click"
    :number="showElement ? number : null"
    :date="date"
    :title="event.title[locale]"
    :text="event ? event.description[locale] : ''"
    )
    template(v-slot:image)
      div(v-if="image && image.data" v-html="image.data")
    template(v-slot:default)
      button(v-if="hasRemoveListener" @click="remove()") Remove
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import CardFront from './CardFront'

export default {
  name: 'EventCardFront',
  components: { CardFront },
  props: {
    event: Object,
    showElement: Boolean,
    showYear: Boolean,
  },
  methods: {
    ...mapGetters('weekdays', ['numberByKey']),
    remove() {
      this.$emit('remove');
    },
    click() {
      this.$emit('click');
    }
  },
  computed: {
    ...mapGetters('assets', ['getAsset']),
    ...mapState('locale', ['locale']),
    ...mapState('weekdays', ['keys']),
    image() {
      return this.event.image ? this.getAsset(this.event.image.sys.id) : undefined;
    },
    number() {
      return this.numberByKey()(this.event.key)
    },
    date() {
      return [
        this.event.day,
        this.event.month,
        this.event.year
        ]
        .filter(d => !!d)
        .join('/');
    },
    hasRemoveListener(){
      return this.$listeners && this.$listeners.remove;
    }
  }
}
</script>

<style scoped lang="stylus">
</style>
